import { render, staticRenderFns } from "./AddImport.vue?vue&type=template&id=40e38182"
import script from "./AddImport.vue?vue&type=script&lang=js"
export * from "./AddImport.vue?vue&type=script&lang=js"
import style0 from "./AddImport.vue?vue&type=style&index=0&id=40e38182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports